import React from 'react';
// 1. THIS IMPORT IS CRITICAL. Check that the filename matches exactly.
import './MaintenancePage.css'; 

const MaintenancePage = () => {
    return (
        <div className="maintenance-wrapper">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-8">
                        <div className="maintenance-card text-center">
                            
                            <div className="brand-logo-placeholder">
                                <img 
                                    src="https://webassets-stage-gcp.narayanagroup.com/narayanagroup/nlearn_white.svg" 
                                    alt="Narayana Logo" 
                                    width="150" 
                                    className="img-fluid mb-3 img-fluid-logo"
                                />
                                <br />
                                <img 
                                    src="https://webassets-gcp.narayanagroup.com/narayana-schools-in/file%20transfer2.gif" 
                                    alt="File Transfer" 
                                    width="350" 
                                    className="img-fluid"
                                />
                            </div>
                            
                            {/* Adjusted margin to prevent overlap */}
                            <h1 className="main-title display-6" style={{ marginTop: '-1em' }}>
                                System Currently Unavailable
                            </h1>

                            <p className="lead-text">
                                The nLearn Digital ecosystem is currently offline for scheduled maintenance and critical upgrades.
                            </p>

                            <div className="resume-alert shadow-sm mx-auto">
                                <i className="far fa-clock me-2"></i> We expect services to resume by:
                                <span className="resume-time">
                                Wednesday, December 17, 2025<br />at 8:00 PM
                                </span>
                            </div>

                            <p className="footer-note">
                                Thank you for your patience and understanding.
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;